export interface PlanningPeriodFilter {
  startDate: string | null;
  endDate: string | null;
}

export interface CalculatedEntriesFilters {
  busPartnerIds: string[];
  lineNumbers: string[];
  planningPeriods: PlanningPeriodFilter;
  countryIds: string[];
  name: string;
  statuses: ProductionCostEntryStatus[];
  origins: ProductionCostEntryOrigin[];
}

export interface CalculatedEntriesState {
  filters: CalculatedEntriesFilters;
  entries: ProductionCostEntry[];

  page: number;
  paginationOutput: {
    totalPages: number | null;
    totalRecords: number | null;
  };
  recordsPerPage: number;
  isReloadData: boolean;

  analyticsMode: boolean;
  analyticsModeType: AnalyticsModeType;
  subtotals: any;
  absoluteValuesSubtotals: any;
  absoluteValuesEntries: any[];
}

export interface ProductionCostEntry {
  busPartnerIds?: string[];
  calculationVersion: string;
  countryIds?: string[];
  createdAt: string;
  endDate: string[];
  id: string;
  lastEditedAt: string;
  lineCount?: number;
  lineNumbers?: string[];
  name: string;
  origin: ProductionCostEntryOrigin;
  actionType: ProductionCostEntryActionType;
  operatingDays?: number;
  planrDataVersion: string; // "1" - rides-based calculation, otherwise - trips-based calculation
  productionCostPerKm?: number;
  publishedAt?: string;
  publishingStatus: ProductionCostPublishingStatus;
  startDate: string;
  status: ProductionCostEntryStatus;
  totalHr?: number;
  totalKm?: number;
  totalWorkingHr?: number;
  usedCurrencies: string[];
  vehicleCount?: number;
}

export enum ProductionCostPublishingStatus {
  NotPublished = 'NOT_PUBLISHED',
  Published = 'PUBLISHED',
  PublishedOutdated = 'PUBLISHED_OUTDATED'
}

export enum ProductionCostEntryOrigin {
  Manual = 'MANUAL',
  Automated = 'AUTOMATED'
}

export enum ProductionCostEntryActionType {
  AutomateCreated = 'AUTOMATE_CREATED',
  ManualCreated = 'MANUAL_CREATED',
  ManualEdited = 'MANUAL_EDITED',
  ManualDeleted = 'MANUAL_DELETED'
}

export enum ProductionCostEntryStatus {
  Draft = 'DRAFT',
  InProduction = 'IN_PRODUCTION',
  Planned = 'PLANNED'
}

export enum AnalyticsModeType {
  Overview = 'OVERVIEW',
  Analytics = 'ANALYTICS',
  AnalyticsAbsolute = 'ANALYTICS-ABSOLUTE'
}
